/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions';
import ToastrService from '../../services/toastrService';
import ErrorMessage from '../common/ErrorMessage';
import * as browserCheck from '../../utils/browserCheck.js';

class CloseAccountPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.closeAccount = this.closeAccount.bind(this);
        this.state = {
            reason: '',
            removeFromMailingList: false,
            error: ''
        };
    }

    componentWillMount() {
    }

    componentDidMount() {  
        if (!this.state.loading && browserCheck.canUseDom()) {
            window.componentHandler.upgradeDom(); 
            window.scrollTo(0, 0);
        }            
    }

    closeAccount(event) {
        event.preventDefault();
        const toastrService = new ToastrService();
        this.props.actions.closeAccount(this.state.reason, this.state.removeFromMailingList)
            .then(payload => {
                toastrService.showSuccess('', 'Your account has now been closed, thanks for giving us a try!');
            })
            .catch(err => {
               this.setState({ error: 'Sorry, something went wrong, unable to close account. Please contact us to investigate.' });
            });
    }

    render() {
        return (
            <div className="main">
                <div className="container">
                    <div className="block-inner">
                        <div className="row">
                            <div className="col-sm-8 col-sm-push-2">
                                <article className="body-copy">
                                    <header>
                                        <h1 className="section-alt">Close your account</h1>
                                    </header>
                                    <form className="form-regular" onSubmit={this.closeAccount}>
                                        <ErrorMessage error={this.state.error} onClose={() => this.setState({ error: null })} />                                          
                                        <p>
                                            Closing your account will delete your login and disable your profiles. Any music, videos, and pictures you have uploaded will be deleted. Any comments you have received will be deleted. Any comments or private messages you have sent will still be visible by the receiver, but they will be unable to see who they were from or reply.
                                        </p>
                                        <p>
                                            <em>If you are having problems with your account, please <Link to="/Contact">contact us</Link> instead and we'll help to resolve it.</em>
                                        </p>
                                        <p>
                                            Please click on 'Confirm' to proceed and close your account. We would <strong>really appreciate</strong> any comments on why you are closing your account to help us to improve.
                                        </p>
                                        <br />
                                        <div className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style={{width:'100%'}}>
                                            <textarea name="Reason" className="mdl-textfield__input" cols="55" rows="4" value={this.state.reason} onChange={(e) => this.setState({ reason: event.target.value })} />
                                            <label className="mdl-textfield__label" htmlFor="Reason">Why are you closing your account?</label>
                                        </div>
                                        <label className="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" htmlFor="RemoveFromMailingList">
                                            <input type="checkbox" className="mdl-checkbox__input" checked={this.state.removeFromMailingList} onClick={(event) => this.setState({ removeFromMailingList: event.target.checked })} />
                                            <span className="mdl-checkbox__label">Remove me from the mailing list</span>
                                        </label>
                                        <br />
                                        <br />
                                        <div className="form-group">
                                            <input className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent mdl-button--wide" type="submit" value="Confirm" />
                                            &nbsp;                                            
                                            <Link to="/" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--dark mdl-button--wide">Cancel</Link>
                                        </div>
                                    </form>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

CloseAccountPage.propTypes = {
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return { user: state.account.user };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CloseAccountPage);